import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  useCurentUser,
  useUpdateUserProfileMutation,
  useUploadfilesMutation,
} from "../../actions/authActions";
import textWeight from "../../utils/textWeight";

export default () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const [loading, setLoading] = useState(false);
  const uploadFileData = useSelector((state) => state.app.uploadFileData);
  const userId = localStorage.getItem("userId");
  const { data: userData, isLoading, isError, error } = useCurentUser(userId);
  const { TextWeight } = textWeight();

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fullname: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      files: "",
    },
  });

  // Update form values when userData is loaded
  useEffect(() => {
    if (userData?.data) {
      setValue("fullname", userData?.data?.fullname);
      setValue("email", userData?.data?.email);
      setValue("phone", userData?.data?.phone);
    }
  }, [userData, setValue]);

  const updateProfileMutation = useUpdateUserProfileMutation(
    setLoadingToapi,
    queryClient
  );
  const uploadMutation = useUploadfilesMutation(setLoading, dispatch);
  const onChangeImage = (e) => {
    setLoading(true);
    const file = e.target?.files?.[0];
    setValue("files", file);
    const formData = new FormData();
    formData.append("files", file);
    uploadMutation.mutate(formData);
  };

  const onSubmitProfile = (data) => {
    setLoadingToapi(true);
    updateProfileMutation.mutate({
      fullname: data.fullname || userData?.data?.fullname,
      password: data.password || userData?.data?.password,
      phone: data.phone || userData?.data?.phone,
      image: uploadFileData || userData?.data?.image,
    });
  };
  const handleFormSubmit = (e) => {
    e.preventDefault(); // prevent the default form submission
    handleSubmit(onSubmitProfile)(e); // call handleSubmit with the event
  };

  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  return {
    register,
    setValue,
    getValues,
    control,
    errors,
    loadingToapi,
    onChangeImage,
    handleFormSubmit,
    isLoading,
    loading,
    uploadFileData,
    userData,
    TextWeight,
  };
};
